import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.QBooksRequestCard', {
    vendorEmailSectionText: 'Email to Vendor',
    attachmentsToVendorTitle: 'Attachments to vendor',
    shippingDetailsHeaderText: 'Shipping Details',
    shipViaFieldTitle: 'Ship via',
    shipAddressFieldTitle: 'Shipping Address',
});
